import i18nResource from "@/config/i18n-resources";
import i18n from "i18next";
import { initReactI18next } from "react-i18next";

i18n.use(initReactI18next).init({
  resources: i18nResource,
  debug: process.env.NODE_ENV === "development",
  lng: "zh", // 默认语言
  fallbackLng: "zh", // 如果当前语言找不到翻译则回退到默认语言
  interpolation: {
    escapeValue: false, // React 已经默认安全转义
  },
});

export default i18n;
